module.exports = __webpack_public_path__ + "img/1280x720-Showtime.6fe6e6ff.jpg";